/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Import_Confirm_OverwriteInputs */



/**
* | output |
* | --- |
* | "This tournament already has rounds. Importing replaces all rounds, standings and results. Continue?" |
*
* @param {Archon_Import_Confirm_OverwriteInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_import_confirm_overwrite = /** @type {((inputs?: Archon_Import_Confirm_OverwriteInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Import_Confirm_OverwriteInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ce tournoi a déjà des rondes. L'import remplace toutes les rondes, le classement et les résultats. Continuer ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Este torneo ya tiene rondas. Importar reemplaza todas las rondas, la clasificación y los resultados. ¿Continuar?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Este torneio já tem rodadas. Importar substitui todas as rodadas, a classificação e os resultados. Continuar?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo torneo ha già dei round. L'importazione sostituisce tutti i round, la classifica e i risultati. Continuare?")
	return /** @type {LocalizedString} */ ("This tournament already has rounds. Importing replaces all rounds, standings and results. Continue?")
});